import { useState, useRef, useCallback, useEffect } from "react"
import * as axios from 'axios';

import Grid from '@material-ui/core/Grid'

import Breadcrumbs from '@base/Breadcrumbs'
import Table from '@base/Table'
import Title from '@base/Title'
import Toast from '@base/Toast'
import Filters from '@base/Filter'
import TextField from '@base/Inputs/Text'
import Loading from "@base/Loading";

import {
  verifyPagingAndSorting,
	PAGE,
	SIZE,
	TOTAL_ELEMENTS,
	TOTAL_PAGES,
} from '@base/Table/Utils'

import { toDateTime } from '@helpers/DateHelper'
import { removePagingAndSorting } from '@helpers/PaginationHelper'

export const Logs = () => {
  const [loading, setLoading] = useState(false);
  const [noContent, setNoContent] = useState(false);

  const [list, setList] = useState([]);

  const [page, setPage] = useState(PAGE);
  const [size, setSize] = useState(SIZE);
  const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
  const [totalPages, setTotalPages] = useState(TOTAL_PAGES);
  
  const [filtros, setFiltros] = useState([]);
  const [filtroAtivo, setFiltroAtivo] = useState(false);

  const [filtroINEP, setFiltroINEP] = useState();
  const [quantidadeFiltrosAplicados, setQuantidadeFiltrosAplicados] = useState(0);

  const toastRef = useRef(null);

  const pageName = 'Logs do Aplicativo';
  const breadcrumbs = [];

  const aplicarFiltros = () => {
    let f = [];

    f.push({ field: 'usuario', value: filtroINEP });
    
    setFiltros(f);
    setFiltroAtivo(true);
    setQuantidadeFiltrosAplicados(f.length);
  }

  const contarFiltrosAplicados = () => quantidadeFiltrosAplicados;

  const limparFiltros = () => {    
    setFiltros([]);
    setFiltroAtivo(false);
    setFiltroINEP('');

    setPage(PAGE);
    setSize(SIZE);
    
    setQuantidadeFiltrosAplicados(0);
  }

  const carregarDados = useCallback(() => {
    const f = verifyPagingAndSorting(removePagingAndSorting(filtros), page, size, [], filtroAtivo);

    if (f.length === 2) // 2 = size + page
      return;

    setLoading(true);

    axios({ 
      method: 'get', 
      url: `${process.env.REACT_APP_LOGS_URL}/auditoria/lista?${f.map(item => `${item.field}=${item.value}`).join('&')}`, 
      auth: { username: '00000000', password: 'impa1234' } 
    })
      .then(res => {
          if (!res.data.content || res.data.content.length === 0) {
            toastRef.current.show("warning", "A escola não possui logs!");
            setNoContent(true)

          } else {
            const { content, number, size, totalElements, totalPages } = res.data;

            setList(content);
            setPage(number);
            setSize(size);
            setTotalElements(totalElements);
            setTotalPages(totalPages);

            /* RESPOSTA
              { 
                content: [
                  {
                    "id": 73,
                    "usuario": "00000000",
                    "acao": "REGISTRAR_CARTAO",
                    "descricaoAcao": "Registro de Cartão",
                    "entidade": "Cartao",
                    "entidadeId": "15",
                    "endpoint": "/cartao",
                    "metodoHttp": "POST",
                    "ip": "0:0:0:0:0:0:0:1",
                    "payload": "[{ ### JSON DE REQUISICAO ### }]",
                    "dataEvento": "2026-06-08T12:23:44.294004",
                    "servico": "CartaoService",
                    "metodoServico": "registrarCartao"
                  },
                  ...
                ],
                ... + ATRIBUTOS DE PAGINACAO
              }
            */
          }
      })
      .catch(() => toastRef.current.show("error", "Ocorreu um Problema ao Realizar os Filtros!"))
      .finally(() => setLoading(false))
  }, [filtros, page, size, filtroAtivo])

  const handlePage = page => { setPage(page); setFiltroAtivo(true); };
	const handleRowsPerPage = (size, page) => { setPage(page); setSize(size); setFiltroAtivo(true); };

  const handleTotalPages = () => totalPages;
	const handleTotalElements = () => totalElements;

  useEffect(() => carregarDados(), [carregarDados]);

  const columns = [
    { label: '#', name: 'id', func: null, key: true, width: "10" },
    { label: 'Usuário', name: 'usuario', func: null, key: false, width: "20" },
    { label: 'Ação Registrada', name: 'descricaoAcao', func: null, key: false, width: "40" },
    { label: 'Data e Hora da Ação', name: 'dataEvento', func: toDateTime, key: false, width: "30" },
  ];

  return (
    <>
      <Toast ref={toastRef} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Breadcrumbs links={breadcrumbs} active={pageName} />
        </Grid>
      </Grid>
      <Title>{pageName}</Title>

      <Filters
        open={true}
        handleFilter={aplicarFiltros}
        handleFilterClear={limparFiltros}
        countFilters={contarFiltrosAplicados}
      >
        <Grid item container spacing={3}>
          <Grid item sm={12} lg={3}>
            <TextField
              label='INEP'
              value={filtroINEP}
              name='filtroINEP'
              onChange={(e) => setFiltroINEP(e.target.value)}
            />
          </Grid>
        </Grid>
      </Filters>
      {loading ?
        <Grid style={{display: "flex", justifyContent: "space-evenly"}}>
            <Loading/>
        </Grid>
        :
        noContent ?
          <Grid style={{display: "flex", justifyContent: "space-evenly"}}>
            <Title>A escola não possui logs</Title>
          </Grid>
        :
          <Table
            columns={columns}
            tableData={list}
            actions={[]}
            page={page}
            handlePage={handlePage}
            handleTotalPages={handleTotalPages}
            handleTotalElements={handleTotalElements}
            rowsPerPage={size}
            handleRowsPerPage={handleRowsPerPage}
            loading={loading}
          />
        }
    </>
  );
}

export default Logs;
